module.exports = __webpack_public_path__ + "img/1F1F3-1F1EB.9ae3639e.svg";